import Vue from 'vue';
import VueResouce from 'vue-resource';
import VueRouter from 'vue-router';
import routes from './routers';
import store from './vuex/store';
import FastClick from 'fastclick';
// 引入公共组件
import netError from './components/common/netError.vue';
import loading from './components/common/loading.vue';  // loading
import myfLoading from './components/common/mfyLoading.vue';
import toast from './components/common/toast.vue';  // loading

// 注册全局组件
Vue.component('netError', netError);
Vue.component('loading', loading);  // loading
Vue.component('myfLoading', myfLoading);
Vue.component('toast', toast);

require('./assets/scss/common/sizeMediaQuery.scss');

Vue.use(VueRouter);
Vue.use(VueResouce);

// 实例化VueRouter
const router = new VueRouter({
    // mode: 'history',
    routes
});
FastClick.attach(document.body);

// 登录中间验证，页面需要登录而没有登录的情况直接跳转登录
router.beforeEach((to, from, next) => {
    next();
});

var vm = new Vue({
    router,
    store
}).$mount('#app');

// 请求api接口时，增加请求前的交互，如显示loading状态（在next前），请求后的的交互，如隐藏loading状态，在next的回调方法里面加--lk
Vue.http.interceptors.push((request, next) => {
    vm.$store.dispatch('LOADING', true);
    next((res) => {
        if (res.ok || !res.ok) {
            vm.$store.dispatch('LOADING', false);
        }
    });
});



// WEBPACK FOOTER //
// ./src/main.js